import {getToken} from '../Utils/Common';
import {getUserInfo} from "./user";

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
let apilink = process.env.REACT_APP_BACKEND_API_URI


//API call to get the LVdashboard data
// export function getAnalysenRequestData() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/analysis`, {
//         method: 'GET',
//         headers: { Authorization: 'Bearer ' + getToken() }
//     })
//         .then((response) => response.json())
//         .then((res) => {
//             return res;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }
export async function getAnalysenRequestData(lvstatus) {

//get company name
let userData = await getUserInfo();


    let link = apilink + "projects/getProject"
    return fetch(`${link}`, {
        method: 'POST',
        headers: {
          //  'Access-Control-Allow-Headers': "*",
        //'Authorization':'Bearer' + '12345',
            'Content-Type': 'application/json',
            //'X-My-Custom-Header': 'value-v',
            //'credentials':'include'
        },
        body: JSON.stringify({"token": getToken(), "project_status": lvstatus, "company_name": userData.company})
    })
        .then((response) => response.json())
        .then((res) => {
            return res;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function getProject(lvID) {
    let projectURL = apilink + "projects/getOneProject";
    let projectBody = JSON.stringify({"token": getToken(), "lvid": lvID });
    const response = await fetch(projectURL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: projectBody
    });
    return response.json();
}


//Called in LVComponent.js to get the parsed lv link
export function getLink() {
    return JSON.parse(localStorage.getItem('lvlink'));
}

//delete the LV,report,aws storage
export async function deleteLV(lvdetails) {
     //projectdelete//
    let link = `${apilink}projects/deletelv`;
    let uid =lvdetails.uid
    let s3url = lvdetails.s3url
    let projectdelete=fetch( `${link}`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"token":getToken(),"lv_id" :uid,"s3url":s3url})
    })
        .then(function (response) {
            return response.clone().json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    console.log(projectdelete)

    //parserdelete//
    link = `${apilink}parser/deletelv`;
    let parserdelete=fetch( `${link}`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"token":getToken(),"lv_id" :uid})
    })
        .then(function (response) {
            return response.clone().json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    console.log(parserdelete)

    //
    //annotatordelete//
    link = `${apilink}annotator/deletelv`;
    let annotatordelete=fetch( `${link}`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"token":getToken(),"lv_id" :uid})
    })
        .then(function (response) {
            return response.clone().json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
        console.log(annotatordelete)



    //analysehandlerdelete//
    link = `${apilink}analysehandler/deletelv`;
    let analysehandlerdelete=fetch( `${link}`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"token":getToken(),"lv_id" :uid})
    })
        .then(function (response) {
            return response.clone().json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
        console.log(analysehandlerdelete)
}

///////detect_encoding/////
export async function detectEncoding(s3uploadURL) {
    let link = process.env.REACT_APP_BASE_URI + "/detect_encoding"
    let body = JSON.stringify({
        s3uploadURL:s3uploadURL
    })
    let fetchData = await fetch(link, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: body
    }).then(data => data.json())
    return fetchData
}


///////get parsed data///////
export async function getParsedData(project) {
    /////get parsed data/////

    let parserURL = apilink + "parser"

    let link = parserURL + "/" + "parse" + (project.status).toLowerCase();
    project.token = getToken()
    if (project.status === "Unknown"){
        let encoding = await detectEncoding(project.s3uploadURL)
        project.encoding=encoding.encoding
    }
    let parserBody = JSON.stringify(project)
    let parserData = await fetch(link, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: parserBody
    }).then(data => data.json())



    // await fetch(paasURL).then(r => r)
    //
    // let platformResponse = axios.post(`${process.env.REACT_APP_BASE_URI}/api/projects/v1/resources/uploadlv`, data, {
    // 	headers: {
    // 		'Content-Type': 'multipart/form-data',
    // 		'Authorization': 'Bearer ' + getToken()
    // 	}
    // })
    //return (await platformResponse).status
    //return platformResponse.status
    //return parserData
    if ((parserData.status === 200) && (project.status === "Unknown")) {
        let url = apilink + "projects/"
        let link = url + "updateprojectstatus";
        let databody = JSON.stringify({"uploadlv_id": project.uploadlv_id, "status": "open",
        "duplication_check":parserData.duplicate_lvid,"token":getToken()})
        await fetch(link, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: databody
        }).then(data => data.json())

    }
    return parserData
}


// import {getToken} from '../Utils/Common';
//
// //API call to get the LVdashboard data
// export function getAnalysenRequestData() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/analysis`, {
//         method: 'GET',
//         headers: { Authorization: 'Bearer ' + getToken() }
//     })
//         .then((response) => response.json())
//         .then((res) => {
//             return res;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }
//
// //Called in LVComponent.js to get the parsed lv link
// export function getLink() {
//     return JSON.parse(localStorage.getItem('lvlink'));
// }
//
// //delete the LV,report,aws storage
// export function deleteLV(uid) {
//     let iLink = `${process.env.REACT_APP_BASE_URI}/api/parser/delete`;
//     console.log(iLink);
//     let fLink = iLink.concat(uid);
//     return fetch(fLink, {
//         method: 'DELETE',
//         headers: {
//             Authorization: 'Bearer ' + getToken()
//         }
//     })
//         .then(function (response) {
//             return response.clone().json();
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

// //delete the LV,report,aws storage
// export function deleteLV(uid) {
//     let iLink = `${process.env.REACT_APP_BASE_URI}/api/parser/delete`;
//     let fLink = iLink.concat(uid);
//     console.log(fLink,"meflink");
//     return fetch(fLink, {
//         method: 'DELETE',
//         headers: {
//             Authorization: 'Bearer ' + getToken()
//         }
//     })
//         .then(function (response) {
//             return response.clone().json();
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

export async function updateProjectStatus(databody){
    let url = apilink + "projects/"
databody.token=getToken()

        let link = url + "updateprojectstatus";

        //let databody = JSON.stringify({"uploadlv_id": lvID, "status": status,"token":getToken() })
        return await fetch(link, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(databody)
        }).then(data => data.json())
}
